import { useNotificationsUnreadCount } from '@repo/queries';
import { Bell } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Tooltip } from '@/components/ui/tooltip';

/**
 * Top-bar notifications bell. Polls the `/notifications/unread`
 * endpoint via React Query so the badge stays roughly in sync with
 * server state without a websocket. The full inbox lives at
 * `/notifications`.
 */
export function NotificationsBell() {
  const navigate = useNavigate();
  const { count } = useNotificationsUnreadCount();

  const display = count > 99 ? '99+' : count > 0 ? String(count) : null;

  return (
    <Tooltip content="Notifications">
      <Button
        variant="ghost"
        size="icon"
        aria-label={`Notifications${count ? `, ${count} unread` : ''}`}
        className="relative"
        onClick={() => navigate('/notifications')}
      >
        <Bell className="size-5" />
        {display ? (
          <span
            data-testid="notifications-badge"
            className="absolute -right-0.5 -top-0.5 inline-flex h-4 min-w-4 items-center justify-center rounded-full bg-destructive px-1 text-[10px] font-semibold text-destructive-foreground"
          >
            {display}
          </span>
        ) : null}
      </Button>
    </Tooltip>
  );
}
